import React, { useState, useEffect } from 'react';
import { ResponsiveGrid } from '@alifd/next';
import { Empty } from 'antd';
import { history } from 'ice';
import { Icon } from '@b-design/fusion';
import store from '@/store';
import NameIcon from '@/components/NameIcon';
import { queryStringify, getQueryStringArgs } from '@/utils/url-parse';
import Requests from '@/services/request';
import $i18n from '@/i18n';

const { Cell } = ResponsiveGrid;
import './index.less';

interface IAppList {
  iconPublicUrl: string;
  name: string;
  innerCode: string;
}

const MiniAppOperate: React.FC = () => {
  const { spaceId } = getQueryStringArgs();
  const [appList, setAppList] = useState<IAppList[]>([]);
  const [spaceRoleState] = store.useModel('spaceRole');
  
  useEffect(() => {
    if (!spaceId) {
      return;
    };
    Requests.get('/rest/intercnn/publishChannel/pageQuery', {
      draftStatus: 'ONLINE',
      currentPage: 1,
      pageSize: 300,
      spaceId,
      belongSpaceId: spaceRoleState?.belongSpaceId || '',
    }).then((res) => {
      setAppList(res.list);
    });
  }, []);

  const jumpUrl = (code) => {
    history?.push(
      `/miniAppStore/setting?${queryStringify({
        spaceId,
      })}&channelCode=${code}`,
    );
  };

  return (
    <div className="operateContainer">
      {appList?.length > 0 ? (
        <ResponsiveGrid gap={10} device="desktop">
          {appList.map((i) => {
            return (
              <Cell className="mygrid" colSpan={2} key={i.innerCode}>
                <div className="operate-item">
                  <div className="item-content">
                    {i.iconPublicUrl ? (
                      <img className="content-icon" src={i.iconPublicUrl} />
                    ) : (
                      <NameIcon
                        name={i?.name}
                        styles={{ width: '56px', height: '56px', fontSize: '30px' }}
                        shape="square"
                      />
                    )}
                    <div className="operate-item-name">{i?.name}</div>
                  </div>
                  <div className="item-mask">
                    <div className="item-mask-setting">
                      {/* <Cell className="mygrid" colSpan={6}>
                            <Popover
                              align="b"
                              v2
                              trigger={
                                <div className="mask-choose">
                                  <Icon type="view--outline" style={{ color: '#FFFFFF' }} />
                                  <div>
                                    {$i18n.get({
                                      id: 'aopf.pages.miniAppStore.operate.setting.preview',
                                      dm: '预览',
                                    })}
                                  </div>
                                </div>
                              }
                              closable={false}
                            >
                              <div className="QRCode-popover">
                                <QRCode value="http://www.baidu.com" size={154} fgColor="#000" />
                              </div>
                            </Popover>
                          </Cell> */}
                      <Cell className="mygrid " colSpan={12}>
                        <div className="mask-choose" onClick={() => jumpUrl(i.innerCode)}>
                          <Icon type="store-management--outline" style={{ color: '#FFFFFF' }} />
                          <div>
                            {$i18n.get({
                              id: 'aopf.pages.miniAppStore.operate.setting.operational.settings',
                              dm: '运营设置',
                            })}
                          </div>
                        </div>
                      </Cell>
                    </div>
                  </div>
                </div>
              </Cell>
            );
          })}
        </ResponsiveGrid>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span>
              {$i18n.get({
                id: 'aopf.pages.miniAppStore.setting.category.list.no.data',
                dm: '暂无数据',
              })}
            </span>
          }
        />
      )}
    </div>
  );
};

export default MiniAppOperate;
